import { combineReducers } from 'redux';
import undoable, { excludeAction } from 'redux-undo';
import { reducer as formReducer } from 'redux-form';

import types from '../actions/types';

import canvas from './canvasReducer';
import objects from './objectsReducer';
import layers from './layersReducer';
import sidebar from './sidebarReducer';
import products from './productsReducer';
import stickers from './stickersReducer';
import fonts from './fontsReducer';
import ads from './adsReducer';
import teams from './teamReducer';
import system from './systemReducer';

export default combineReducers({
  canvas,
  layers,
  sidebar,
  products,
  stickers,
  fonts,
  ads,
  teams,
  system,
  objects: undoable(objects, { filter: excludeAction([
      types.SELECT_OBJECT,
      types.DESELECT_OBJECTS,
      types.SELECT_SURFACE
    ])
  }),
  form: formReducer
});


// WEBPACK FOOTER //
// ./src/reducers/index.js